console.log('[MAIN] 🎬 Application starting - main.tsx executing');

import React from 'react';
import * as ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from './store';
import App from './App';
import './index.css';
import apiService from './services/api';

// Cleanup legacy client-side Supabase connections

// Add debugging utilities to window object for development
if (import.meta.env.DEV) {
  (window as any).debugAPI = {
    resetCircuitBreakers: () => apiService.resetAllCircuitBreakers(),
    clearPendingRequests: () => apiService.clearPendingRequests(),
    resetSpecificBreaker: (key: string) => apiService.resetCircuitBreaker(key),
    help: () => {
      console.log(`
🛠️  API Debug Utilities:
debugAPI.resetCircuitBreakers() - Reset all circuit breakers
debugAPI.clearPendingRequests() - Clear all pending requests  
debugAPI.resetSpecificBreaker('GET-/projects') - Reset specific endpoint
debugAPI.help() - Show this help
      `);
    }
  };
  console.log('🛠️  API Debug utilities available: window.debugAPI.help()');
}

// Get the root element
const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Failed to find the root element');

console.log('[MAIN] 🏪 Redux store initialized');
console.log('[MAIN] 🎨 CSS loaded');

// Create React root and render the application
ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);

console.log('[MAIN] ⚛️ React app rendered to DOM'); 